import { createHeadlessEditor } from '@lexical/headless'
import { LinkNode } from '@lexical/link'
import { ListItemNode, ListNode } from '@lexical/list'
import { HeadingNode } from '@lexical/rich-text'
import { type CreateEditorArgs, type Klass, type LexicalNode } from 'lexical'
import { EmailNode } from './EmailNode'
import { GroupNode } from './GroupNode'
import { LockedBlockNode } from './LockedBlockNode'
import { SlotNode } from './SlotNode'
import { VariableNode } from './VariableNode'

export const EMAIL_NODES: Klass<LexicalNode>[] = [EmailNode, SlotNode, GroupNode, LockedBlockNode, VariableNode, HeadingNode, ListNode, ListItemNode, LinkNode]

export const createEmailEditor = (config: CreateEditorArgs = {}) =>
  createHeadlessEditor({
    nodes: EMAIL_NODES,
    onError: (error) => {
      throw error
    },
    ...config,
  })
